import React,{useContext} from 'react';
import { Link } from 'react-router-dom';
import './ExpiredSubscriptionPage.css'; // 👈 Import CSS here
import { LocationContext, LocationProvider } from '../../reducers/LocationContext';

function ExpiredSubscriptionPage() {
  let { countryCode } = useContext(LocationContext);
  
  return (
    <div className="centered">
      <h1>Your Subscription Has Expired</h1>
      <p>Please renew your subscription to access this content.</p>
      {countryCode === "IN" ? (
        <Link to="/subscribe">
          <button>Renew Now</button>
        </Link>
      ) : (
        <Link to="/subscription">
          <button>Renew Now</button>
        </Link>
      )}  
      
    </div>
  );
}

export default ExpiredSubscriptionPage;
